import { authHeaders, getAccessToken, getChatBase } from '../../components/AiAssistant/chatApiBase'
import { Memory } from './memoryModel'

/**
 * The caller's memories, or `null` when chat has the feature off for them.
 *
 * Chat answers 404 while `chat-memory` is off for the caller's tenant
 * (chat#258), and that is how the Account page knows to hide the section.
 */
export async function listMemories(): Promise<Memory[] | null> {
  const res = await fetch(`${getChatBase()}/memories`, { headers: authHeaders(getAccessToken()) })
  if (res.status === 404) {
    return null
  }
  if (!res.ok) {
    throw new Error(`Failed to load memories: ${res.status}`)
  }
  const data = await res.json()
  return data.memories
}

/** Delete one of the caller's memories. A memory that is already gone counts. */
export async function deleteMemory(memoryId: string): Promise<void> {
  const res = await fetch(`${getChatBase()}/memories/${memoryId}`, {
    method: 'DELETE',
    headers: authHeaders(getAccessToken()),
  })
  if (res.status === 404) {
    return
  }
  if (!res.ok) {
    throw new Error(`Failed to delete memory: ${res.status}`)
  }
}
